module.exports = __webpack_public_path__ + "img/stethoscope.d953df9a.png";